"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsAgreeFitProtocal = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var financial_1 = require("../../model/financial");
var service_1 = require("../../../library/base/service");
var IsAgreeFitProtocal = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(IsAgreeFitProtocal, _super);
    function IsAgreeFitProtocal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '判断用户是否查看协议接口';
        _this.code = '101107';
        _this.desc = "";
        _this.requestParams = new financial_1.IsAgreeFitProtocalRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return IsAgreeFitProtocal;
}(service_1.BaseService));
exports.IsAgreeFitProtocal = IsAgreeFitProtocal;
//# sourceMappingURL=isAgreeFitProtocal.js.map